import React, {lazy, useMemo, Suspense} from "react";
import { Link } from "react-router-dom";
import "./Headers.css";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { OpenLoginSignUp } from "../../Actions/ToggleSignupA";
const OtherHeader = lazy(() => import("./Components/Others Header/Others Header"));
const StudentHeader = lazy(() => import("./Components/StudentHeader/StudentHeader"));
const AdminHeader = lazy(() => import("./Components/AdminHeader/AdminHeader"));

const Headers = ({ setAuthPageName }) => {
  const [ShowSidebar, setShowSidebar] = useState(false);
  const { UserInfo } = useSelector((store) => store.LoginSignupReducer);
  // const admin = userInfo?.User === "Admin";
  // const instituteUser = userInfo?.User === "Institute";

  const { admin, instituteUser, isStudentOrGuest } = useMemo(() => {
    return {
      admin: UserInfo?.User === "Admin",
      instituteUser: UserInfo?.User === "Institute",
      isStudentOrGuest: !UserInfo?.User || UserInfo?.User === "Student",
    };
  }, [UserInfo]);

  return (
    <header className="Header" onClick={(e) => e.stopPropagation()}>
      <div
        className={`HeaderDataContainer ${
          admin || instituteUser ? "HeaderDataContainer_2" : null
        }`}
      >
        {isStudentOrGuest && (
          <Suspense fallback={null}>
            <StudentHeader
              ShowSidebar={ShowSidebar}
              setShowSidebar={setShowSidebar}
            />
          </Suspense>
        )}
        {admin &&  (
          <Suspense fallback={null}>
            <AdminHeader
              setShowSidebar={setShowSidebar}
              ShowSidebar={ShowSidebar}
            />
          </Suspense>
        )}
        {instituteUser && (
          <Suspense fallback={null}>
            <OtherHeader
              setShowSidebar={setShowSidebar}
              ShowSidebar={ShowSidebar}
            />
          </Suspense>
        )}
      </div>
    </header>
  );
};

export function LoginRegister() {
  const Dispatch = useDispatch();

  return (
    <nav
      id="RegisterPortion"
      className="absolute right-7 top-24 z-20 hidden w-auto items-center justify-center gap-9 lg:flex"
    >
      <Link
        className="Regularfont  text-xs text-white no-underline xl:text-2xs"
        onClick={() => Dispatch(OpenLoginSignUp("Sign In", true))}
      >
        Login
      </Link>
      <Link
        className={` Regularfont rounded-[25px] bg-[#EA52C6] text-center text-xs text-white
                                    no-underline     lg:py-3         lg:px-7
                                    xl:py-4     xl:px-10        xl:text-2xs 
                        2xl:py-5                 2xl:px-12       `}
        onClick={() => Dispatch(OpenLoginSignUp("Sign Up", true))}
      >
        Register
      </Link>
    </nav>
  );
}

export default React.memo(Headers);